import { useUser } from '@clerk/clerk-react';

export function useRole() {
  const { user } = useUser();
  const role = user?.publicMetadata?.role || null;
  const clientId = user?.publicMetadata?.client_id || null;

  const isSuperAdmin = role === 'super_admin';
  const isTeamMember = role === 'team_member';
  const isClientAdmin = role === 'client_admin';
  const isClientMember = role === 'client_member';
  const isWebciteStaff = isSuperAdmin || isTeamMember;
  const isClient = isClientAdmin || isClientMember;

  return {
    role,
    clientId,
    isSuperAdmin,
    isTeamMember,
    isClientAdmin,
    isClientMember,
    isWebciteStaff,
    isClient,
    isClientOrMember: isClient,
    canDelete: isWebciteStaff,
    canBulkDelete: isWebciteStaff,
    canPushToManyReach: isWebciteStaff,
    canSendToClient: isWebciteStaff,
    canRunEnrichment: true,
    canRunSignals: true,
    canViewAllClients: isWebciteStaff,
    canManageUsers: isSuperAdmin,
    canAccessPrompts: isWebciteStaff,
    canAccessSettings: isSuperAdmin,
  };
}
